/* pLength = Total Length. cLength = Length of thing to center */
module.exports = function findCenter(pLength, cLength){
    return (pLength - cLength)/2
}